import { TextInput, SelectInput } from 'react-admin';
import {
  ADS_JOB_TYPES,
  ADS_JOB_SCHEDULES,
  ADS_JOB_ENABLED_CHOICES
} from '../../../../../helpers/adsJobsConstants';

export const getAdsJobsFilters = () => [
  <SelectInput
    source="type"
    label="Type"
    choices={ADS_JOB_TYPES}
    alwaysOn
    className="input-width-md"
  />,
  <SelectInput
    source="enabled"
    label="Enabled"
    choices={ADS_JOB_ENABLED_CHOICES}
    alwaysOn
    className="input-width-md"
  />,
  <SelectInput
    source="schedule"
    label="Schedule"
    choices={ADS_JOB_SCHEDULES}
    alwaysOn
    className="input-width-md"
  />,
  <TextInput source="name" label="Name" alwaysOn />
];
